<template>
  <div>
    <div class="programs">
      <div class="container">
        <div class="slider-cards">
          <div class="sc-header mb-4">
            <div class="title main-color">Explore Our Programs </div>
            <div class="divider"></div>
            <div class="arrows-slider">
              <button class="swiperPrev" slot="button-prev" @click="prev()">
                <img src="../../assets/img/icons/arrow-left.svg" class="img-fluid" alt="" />
                </button>
              <button class="swiperNext" slot="button-next" @click="next()">
                <img src="../../assets/img/icons/arrow-right.svg" class="img-fluid" alt="" />
              </button>
            </div> 
          </div>

          <div id="porgramsCards">
            <swiper ref="mySwiper" :options="swiperOptions">
                <swiper-slide v-for="(row, index) in rows" :key="index">
                  <div>
                    <img :src="row.image" class="program-view img-fluid" alt="" />
                    <div :style="{backgroundColor: row.bgColor}" class="program-details">
                      <div class="title white-color" v-html="row.title"></div>
                      <router-link :to="row.redirect" class="btn-line btn-line-white">{{ row.button }}</router-link>
                    </div>
                  </div>  
                </swiper-slide>      
            </swiper>
          </div>

        </div>
      </div>
    </div>
    <!-- <swiper ref="mySwiper" :mySwiper="swiperOption">
      <swiper-slide>Slide 1</swiper-slide>
      <swiper-slide>Slide 2</swiper-slide>
      <swiper-slide>Slide 3</swiper-slide>
      <swiper-slide>Slide 4</swiper-slide>
      <swiper-slide>Slide 5</swiper-slide>
    </swiper> -->
    <!-- <button class="swiperNext" slot="button-next" @click="next()">Next button</button> -->
    <!-- <button class="swiperprev" slot="button-prev" @click="prev()">Prev button</button> -->
  </div>
</template>

<script>
// Very Important npm install swiper@5.4.5 
import axios from 'axios';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      rows: [],
      swiperOptions: {
        loop: false,
        autoplay: {
          // delay: 4000, or data-swiper-autoplay="2000" in html
        },
        spaceBetween: 30,
        // slidesPerView: 3,
        navigation: {
            nextEl: '.swiperNext',
            prevEl: '.swiperPrev'
        },
        breakpoints: {
          767: {
            slidesPerView: 1
          },
          800: {
            slidesPerView: 2
          },
          1200: {
            slidesPerView: 3
          }
        }
      }
    }
  },
  created() {
    this.fetchSlider();
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  methods: {
    prev() {
			this.$refs.mySwiper.$swiper.slidePrev();
		},
		next() {
			this.$refs.mySwiper.$swiper.slideNext();
		},
    fetchSlider() {
      axios
        .get(window.baseURL + "/programsInHome")
        .then((res) => {
          this.pgLoading = false;
          const data = res.data.row;
          this.rows = data;
          console.log(data);
        })
        .catch(() => {});
    },
  },
  mounted() {
    console.log('Current Swiper instance object', this.swiper)
    this.swiper.slideTo(3, 1000, false)
  }
}
</script>